<article
  class="new-content-card" [class.mobile]="deviceService.isMobile()"
  itemscope [attr.itemtype]="schemaOrgItemtype">

  <meta itemprop="url" content="{{ contentUrl }}"/>
  <meta itemprop="name" content="{{ fullTitle }}"/>
  <meta itemprop="datePublished" content="{{ hlp_dateToISOString(contentDate) }}"/>
  <meta itemprop="image" content="{{ metaImageUrl || coverImageUrl }}"/>
  <!-- <meta *ngIf="description" itemprop="description" content="{{ description | striptags }}"/> -->
  <meta itemprop="headline" content=""/>
  <!-- <meta itemprop="publisher" content="htts://onclass.com"/> -->
  <!-- keywords -->
  <meta itemprop="inLanguage" content="{{ item.language?.code }}"/>
  <!-- discussionUrl -->
  <meta *ngIf="item.stats" itemprop="commentCount" content="{{ item.stats.comments_count }}"/>

  <div *ngIf="!linkEnable && isBrowser" class="card-cover"></div>

  <div class="cover-wrap">
    <on-ui-cover [cover]="cover"></on-ui-cover>
  </div>

  <div class="meta">
<!--    <a [routerLink]="accountRoute(author)" class="author-name normal">{{ authorName }}</a>-->
    <span class="author-name normal"><span itemprop="author">{{ authorName }}</span></span>

    <a [routerLink]="contentRoute(item)" class="meta-link">
      <span class="subject bold">{{ subject }}</span>
      <span class="title bold">
        <span>{{ item.title }}</span>
      </span>
      <span class="content-type-and-level normal">
        {{ (contentTypeTitle | customLocale) + ', ' + (level | customLocale) | cutText: cutLength }}
      </span>
    </a>
  </div>
</article>
